import React, { useEffect, useState } from "react";

const PdfViewer = ({ base64String, invoice, prefijo }) => {
  return (
    <div>
      <a
        href={`data:application/octet-stream;base64,${base64String}`}
        download={`${prefijo ? prefijo : 'FV'}-${invoice}.pdf`}
        style={{ marginTop: "20px", display: "inline-block" }}
      >
        Descargar Documento PDF
      </a>
      <br />
      <br />
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <object
          style={{
            width: "90%",
            height: "450pt",
          }}
          type="application/pdf"
          data={`data:application/pdf;base64,${base64String}`}
        >
          Lo sentimos, no se puede mostrar el Documento.
        </object>
      </div>
    </div>
  );
};

export default PdfViewer;
